import type { CCAMActe } from "cadendar-shared";

export interface CCAMActeCardProps {
  acte: CCAMActe;
  onSelect?: (acte: CCAMActe) => void;
}

/**
 * Carte d'affichage pour un acte CCAM
 * Story 2.4: Version simplifiée pour les résultats de recherche
 * Story 2.5: Version complète avec plus de détails
 */
export const CCAMActeCard = ({ acte, onSelect }: CCAMActeCardProps) => {
  const tarifValue =
    typeof acte.tarif === "number"
      ? acte.tarif
      : Number.parseFloat(String(acte.tarif));
  const formattedTarif = Number.isFinite(tarifValue)
    ? tarifValue.toFixed(2)
    : "0.00";

  const handleClick = () => {
    if (onSelect) {
      onSelect(acte);
    }
  };

  return (
    <button
      onClick={handleClick}
      className="w-full min-h-[120px] p-4 bg-white border border-gray-200 rounded-lg hover:border-blue-500 hover:shadow-md transition-all text-left"
      aria-label={`Sélectionner l'acte ${acte.code}`}
    >
      <div className="flex items-start justify-between mb-2">
        <span className="font-mono font-semibold text-sm text-blue-600">
          {acte.code}
        </span>
        <span className="text-sm font-bold text-gray-900">
          {formattedTarif} €
        </span>
      </div>
      <p className="text-sm text-gray-900 mb-2 line-clamp-2">{acte.libelle}</p>
      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>{acte.acteType}</span>
        {acte.isExpired && (
          <span className="px-2 py-1 bg-red-100 text-red-700 rounded">
            Périmé
          </span>
        )}
      </div>
    </button>
  );
};
